import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40069d2c&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40069d2c')) {
      api.createRecord('40069d2c', component.options)
    } else {
      api.rerender('40069d2c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=40069d2c&functional=true", function () {
      api.rerender('40069d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nested/menu1/menu1-2/menu1-2-2/index.vue"
export default component.exports